import { useAllSearchParams } from 'storfox-route-hooks'
import { useCreate, useLimitedCountList } from 'storfox-api-hooks'

import { queryToParams } from '~/utils'
import * as API from '~/constants/api'

import { LocationUnitFilterSerializer } from '../../serializers/LocationUnit'

export const useLocationUnitReportList = () => {
  const searchParams = useAllSearchParams()

  const params = queryToParams(LocationUnitFilterSerializer, searchParams, 'guid')

  return useLimitedCountList(API.UNIT_NUMBER_LIST, params)
}

export const useLocationUnitGenerate = () => {
  const searchParams = useAllSearchParams()
  const params = queryToParams(LocationUnitFilterSerializer, searchParams, 'guid')
  const { create, ...state } = useCreate(API.LOCATION_UNIT_REPORT)

  return { ...state, export: () => create(params) }
}
